import { DEFAULT_USER_AGENT } from './device.constants';
import { platformInfo } from './device.constants';

export function isIOSSystem(userAgent: string = DEFAULT_USER_AGENT): boolean {
  return platformInfo?.osName.toLowerCase() === 'ios' || /iPad|iPhone|iPod/.test(userAgent);
}
